import { gql } from '@apollo/client'

export default gql(`
    mutation sendAntiPiracyAction ( $userId: String!  $actionKey: String!  $operatorNote: String!  ) {
        sendAntiPiracyAction (
            userId: $userId
            actionKey: $actionKey
            operatorNote: $operatorNote
        ) {
            statusCode
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
